import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import inputnewboll from '@/views/private/realestate/ocurrence/components/addocurrence/components/inputnewboll.vue'

export default {
  name: 'Panelenterprise',
  mixins: [ActionsForm, ExpenseMixin],
  props: {
    dataDetails: {
      type: Object,
      default: {}
    },
    statusOcorencia: {
      type: Number,
      default: 0
    },
    refreshSubmit: {
      type: Boolean,
      default: false
    },
    teste: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    teste () {
      this.getTriagembyid(this.dataDetails)
    }
  },
  data () {
    return {
      dataAllsStatus: [],
      localDetails: {},
      status: 0
    }
  },
  components: {
    inputnewboll
  },
  mounted () {
    this.getTriagembyid(this.dataDetails)
    this.getAllStatusOccourence()
  },
  computed: {
    getStatus: function () {
      if (this.dataAllsStatus.length === 0) return ''
      let status = this.dataAllsStatus.find((Element) => parseInt(Element.value) === this.statusOcorencia)
      return status.text
    },
    getcolor () {
      if (this.statusOcorencia === 1) return '#9A9898'
      if (this.statusOcorencia === 2) return '#0077FF'
      if (this.statusOcorencia === 3) return '#008144'
      if (this.statusOcorencia === -1) return 'red'
      return '#2E973D'
    }
  },
  methods: {
    getTriagembyid (e) {
      let id = e.id
      loading.push()
      OcurrenceRepository.GetTriagemById(id)
        .then((res) => {
          this.localDetails = res.data
          loading.pop()
        })
        .catch(() => {})
    },
    getAllStatusOccourence () {
      loading.push()
      OcurrenceRepository.GetStatusOcorrencia()
        .then((Response) => {
          loading.pop()
          this.dataAllsStatus = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/painelocorrence/painelocorrence.js